const Avatar = {
   parts: ['container', 'label'],
   sizes: {
      md: {
         container: {
            height: 9,
            width: 9,
         },
         label: {
            fontSize: '90%',
         },
      },
   },
};

export default Avatar;
